/**
 * Foundation bridge to owl carousel
 */

import $ from 'jquery';
import { Foundation } from 'foundation-sites/js/foundation.core';

import 'owl.carousel/src/js/owl.carousel';
import 'owl.carousel/src/js/owl.autoheight';
import 'owl.carousel/src/js/owl.navigation';
import 'owl.carousel/src/js/owl.support';

import 'libs/owl.lazyload';
import 'libs/owl.linkedPreview';
import 'libs/owl.itemSelectorResponsive';
import 'libs/owlcarousel2-a11ylayer';
import 'libs/owl.inAccordion';

class Carousel {
    constructor(element, options) {
        this.$element = element;
        this.options = $.extend({}, Carousel.defaults, this.$element.data(), options);

        this.resize();
        this.events();

        this.$element.owlCarousel(this.options);

        Foundation.registerPlugin(this, 'Carousel');
    }

    destroy() {
        this.$element.trigger('destroy.owl.carousel');
        // TODO: check next two lines for necessity
        this.$element.off("initialized.owl.carousel.navigation");
        this.$element.off("resize.zf.carousel");
        Foundation.unregisterPlugin(this);
    }

    /**
     * Bind all events
     */
    events() {
        this.$element.on("initialized.owl.carousel.navigation", (e) => {
            // Add the corresponding item number to the owl-dots for screen readers.
            this.$element.find(".owl-dot").each(function(index) {
                let $this = $(this);
                if($this.text().trim() == "") {
                    $this.append("<span class='show-for-sr'>" + (index + 1) + "</span>");
                }
            });
        });

        this.$element.on("resize.zf.carousel", (e) => {
            e.stopPropagation();
            this.resize();
        });
    }

    /**
     * Handle resize event
     */
    resize() {
        // We need to resize the more links to width of carousel item.
        // The teaser are equal height using padding, margin and overflow hidden
        // The more link need to be absolute positioned at bottom, requires resize to width of teaser item
        if (this.$element.hasClass("teaser-box") && $(".teaser-with-more", this.$element).length) {
            this.$element.on("initialized.owl.carousel resize.owl.carousel", function () {
                setTimeout(()=> {
                    let $this        = $(this);
                    let $item        = $(".owl-item", $this);
                    let $moreWrapper = $(".more-wrapper", $item);
                    let $more        = $(".more", $moreWrapper);
                    $moreWrapper.css({
                        "margin-right": $item.css("margin-right"),
                        "width": $item.width(),
                        "padding-right": 0
                    });
                    $more.css({"margin-right": 0});
                }, 10)
            });
        }
    }
}

/**
 * Default settings
 *
 * Hint: use the owl keys to overwrite the defaults of owl
 * TODO: Translate static text
 *
 * @type {{nav: boolean, loop: boolean, autoplay: boolean, center: boolean, items: number}}
 */
Carousel.defaults = {
    nav: true,
    rewind: true,
    loop: false,
    autoplay: false,
    center: true,
    slideBy: 'page',
    items: 1,
    navText: ['<span class="show-for-sr">Next</span>', '<span class="show-for-sr">Previous</span>'],

    // fix a bug of owlCarousel that prevents vertical scroll on IE mobile
    // https://github.com/OwlCarousel2/OwlCarousel2/issues/1211
    // https://github.com/OwlCarousel2/OwlCarousel2/blob/c802715c801829f0618f3a957630b1bff93bf985/src/js/owl.carousel.js#L667
    touchDrag: !window.navigator.msPointerEnabled
};

Foundation.plugin(Carousel, "Carousel");

export default Carousel;